import React, { FC } from 'react';
import Picture from '../../../@shared/picture';
import { TFooterProps } from '../../types/splashComponent.types';

const Footer: FC<TFooterProps> = ({ model }) => {
  return (
    <div className="splash-component-footer splash-component__container">
      <Picture
        editorialImageProps={{
          desktopImage: model.footerLogo,
          desktopTransformation: 'Size200',
          cssClassImageEl: 'splash-component-footer__logo',
          cssClassPictureEl: 'splash-component-footer__picture'
        }}
      />
      <span className="splash-component-footer__copyright">{model.copyrightText?.value}</span>
    </div>
  );
};

export default Footer;
